import React, { FC, useEffect, useRef, useState } from 'react';
import Tooltip from 'src/components/UI/Tooltip/Tooltip';

interface DivCalcTooltipProps {
  text: string;
  className?: string;
  hoveredElementKey?: string | number | null | undefined;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}
const DivCalcTooltip: FC<DivCalcTooltipProps> = ({
  text,
  className,
  placement,
  hoveredElementKey,
}) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const divRef = useRef<HTMLDivElement>(null);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [disabledTooltip, setDisableTooltip] = useState<boolean>(true);

  const handleMouseEnter = () => setIsTooltipOpen(true);

  const handleMouseLeave = () => setIsTooltipOpen(false);

  useEffect(() => {
    if (
      tooltipRef?.current &&
      divRef?.current &&
      isTooltipOpen &&
      hoveredElementKey
    ) {
      setDisableTooltip(
        !(divRef.current.scrollWidth > tooltipRef.current.offsetWidth)
      );
    } else {
      setDisableTooltip(true);
    }
  }, [tooltipRef.current, text, isTooltipOpen, hoveredElementKey]);
  return (
    <div
      className={`text-ellipsis ${className}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={divRef}
    >
      {text}
      {isTooltipOpen && (
        <Tooltip
          placement={placement}
          open={!disabledTooltip}
          customRef={tooltipRef}
          className="table-tooltip"
          dropdownClassName={'table-tooltip-message'}
          message={text}
          maxWidth={300}
        />
      )}
    </div>
  );
};
export default DivCalcTooltip;
